<template>
    <component
        :is="linkConfig.component"
        v-bind="linkConfig.attrs"
    >
        <slot />
    </component>
</template>

<script>
export default {
    props: {
        link: {
            type: Object,
            required: true,
        },
        fallbackElement: {
            type: String,
            required: false,
            default: 'div'
        }
    },
    computed: {
        isWeblink() {
            return this.link && this.link.link_type === 'Web';
        },
        isPrismicLink() {
            return this.link 
                && this.link.link_type === 'Document' 
                && this.$validateContentRelationship(this.link);
        },
        resolvedLink() {
            if (this.isWeblink) {
                return this.link.url;
            }
            if (this.isPrismicLink) {
                return this.$prismic.linkResolver(this.link);
            }
            return null;
        },
        hasValidLink() {
            return this.isWeblink || this.isPrismicLink;
        },
        component() {
            if (this.isWeblink) {
                return 'a';
            }
            if (this.isPrismicLink) {
                return 'nuxt-link';
            }
            return this.fallbackElement;
        },
        attributes() {
            if (this.isWeblink) {
                return {
                    href: this.resolvedLink,
                    target: '_blank',
                    rel: 'noopener noreferrer'
                };
            }
            if (this.isPrismicLink) {   
                return {
                    to: this.resolvedLink,
                    target: '_self',
                };
            }
            return null;
        },
        linkConfig() {
            return {
                component: this.component,
                attrs: this.attributes
            };
        }
    }
};
</script>